import { render, staticRenderFns } from "./fourNurse.vue?vue&type=template&id=06b526ea&scoped=true"
import script from "./fourNurse.vue?vue&type=script&lang=ts"
export * from "./fourNurse.vue?vue&type=script&lang=ts"
import style0 from "./fourNurse.vue?vue&type=style&index=0&id=06b526ea&prod&lang=scss&scoped=true"
import style1 from "./fourNurse.vue?vue&type=style&index=1&id=06b526ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b526ea",
  null
  
)

export default component.exports